module.exports = __webpack_public_path__ + "img/thumb-dagohoy.0d5fc417.png";